import Section from '../Section';
import Parallax from '../global/Parallax';

export default class CollectionListSection extends Section {

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.parallax = new Parallax(theme, element.parentNode);
  }
}
